<template>
  <div :class="'tab-button '+(active?'active':'')">
  <router-link :to="url">
    <slot></slot>
  </router-link>
  </div>
</template>

<script>
export default {
  name: "TabButton",
  data:function ()
  {
    return {
      active:false
    }
  },
  methods:{
    checkUrl(url)
    {
      if (this.url==='/Shop' && url==='/ShopCart')
      {
        return false;
      }
      if (this.url==='/')
      {
        if (url === '/')
          return true
        return false;
      }
      if (url.indexOf(this.url) >= 0)
        return true;
      if (this.urls && Array.isArray(this.urls))
      {
        for (let i=0;i<this.urls.length;i++)
        {
          if (url.indexOf(this.urls[i]) >= 0)
            return true;
        }
      }
      return false;
    }
  },
  mounted()
  {
    this.active = this.checkUrl(this.$route.fullPath);
  },
  watch: {
    '$route.path': {
      handler(newUrl)
      {
        this.active = this.checkUrl(newUrl);
      }
    }
  },
  props:['url','urls']
}
</script>

<style scoped>

</style>